import "../styles/css/login.css"
import "../styles/css/admin-style.css"
import {useContext, useEffect, useState} from "react";
import $ from "jquery";
import zxcvbn from 'zxcvbn'; 
import {AuthenticationHandler} from "../components/auth/AuthenticationHandler";
import {useNavigate, useParams} from "react-router-dom";
import {authService} from "../services/authService";
import NotificationService from "../services/NotificationService";
import PasswordStrengthBar from "react-password-strength-bar";

interface LoginData {
    email: string;
    password: string;
    confirmPassword: string;
}

const AdminLoginPage: React.FC = () => {
    const [score, setScore] = useState(0);
    const [isTooShort, setIsTooShort] = useState(false);
    const [isTooWeak, setisTooWeak] = useState(false);
    const [doesNotMatch, setdoesNotMatch] = useState(false);
    const [showErrors, setShowErrors] = useState(false);
    const [loginData, setLoginData] = useState<LoginData>({ email: '', password: '', confirmPassword: '' });
    const auth = useContext(AuthenticationHandler);
    const navigate = useNavigate();
    const { userId, token } = useParams();
    useEffect(() => {
        $(window).on('load', () => {
            $('.pre-loader').fadeOut('fast');
        });
        return () => {
            $(window).off('load');
        };
    }, []);

    useEffect(() => {
        document.body.classList.add("login-body");
        return () => document.body.classList.remove("login-body");
    }, []);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        const score = zxcvbn(loginData.password);
        const doesNotMatchLocal = loginData.password !== loginData.confirmPassword;
        const isTooWeakLocal = score.score < 3;
        const isTooShortLocal = loginData.password.length < 8;
        setdoesNotMatch(doesNotMatchLocal);
        setisTooWeak(isTooWeakLocal);
        setIsTooShort(isTooShortLocal);
        setShowErrors(true);
        if(!doesNotMatchLocal && !isTooShortLocal && !isTooWeakLocal){
            try{
                await authService.setPassword(userId, token, loginData.confirmPassword);
                NotificationService.success("Password Updated")
                navigate("/admin-login");
            }catch (error) {
                NotificationService.handleError(error)
            }
            
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setLoginData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    return (
        <div className="loginBody">
            <div className="container text-center fullHeight">
                <div className="row d-flex align-items-center justify-content-center" style={{height: "100%"}}>

                    <div className="lRight col-12">

                        {/*!--New Password --*/}
                        <div id="new-password" className={`loginDiv`}>
                            <div className="logoContainer">
                                <img src="/logo/logo.svg" alt="Barreca logo" className="logo"/>
                            </div>
                            <div className="loginMessage">
                                <div className="messageHeader">Create New Password</div>
                            </div>
                            <form onSubmit={handleSubmit}>
                                <fieldset className="form-group">
                                    <div className="form-floating">
                                        <input type="password" className="form-control form-control-lg"
                                               placeholder="Password" name="password" value={loginData.password}
                                               onChange={handleChange}/>
                                        <label>New Password</label>
                                    </div>
                                </fieldset>
                                <div className="my-3">
                                    <PasswordStrengthBar password={loginData.password} 
                                                         onChangeScore={(score: number) => setScore(score)}
                                                         minLength={8}/>
                                </div>
                                <fieldset className="form-group mt-3">
                                    <div className="form-floating">
                                        <input type="password" className="form-control form-control-lg"
                                               placeholder="Confirm Password" name="confirmPassword"
                                               value={loginData.confirmPassword}
                                               onChange={handleChange}/>
                                        <label>Confirm New Password</label>
                                    </div>
                                </fieldset>
                                {showErrors && <div className="mb-4 mt-4">
                                    {isTooShort && <div className="alert alert-danger">
                                        Password must be at least 8 characters.
                                    </div>}
                                    {doesNotMatch && <div
                                        className="alert alert-danger">
                                        Passwords must match.
                                    </div>}
                                    {isTooWeak && <div
                                        className="alert alert-danger">
                                        Password must be at least strength 3
                                    </div>}
                                </div>}
                                <fieldset className="mt-4">
                                    <button type="submit"
                                            className="btn btn-lg btn-block btn-primary login-btn w-100 text-white">Set
                                        New Password
                                    </button>
                                </fieldset>
                            </form>
    <div className="login-links mt-3">
    </div>
</div>


</div>

</div>


</div>
</div>
)
    ;
};

export default AdminLoginPage;
